import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
    dimScreen: false,
    isTopbarContextMenuOpen: false,
    isSidebarExpanded: false,
    userToken: 'null',
};

export const globalSlice = createSlice({
    name: 'global',
    initialState: Object.assign({}, INITIAL_STATE),
    reducers: {
        toggleDimScreen: (state, _) => {
            if (state.dimScreen) {
                state.isTopbarContextMenuOpen = false;
                state.isSidebarExpanded = false;
            }
            state.dimScreen = !state.dimScreen;
        },
        togglTopbarContextMenu: (state, _) => {            
            state.dimScreen = !state.dimScreen;
            state.isTopbarContextMenuOpen = !state.isTopbarContextMenuOpen;
        },
        toggleRightSidebar: (state, data) => {
            const shouldDim = data.payload ?? false;
            state.dimScreen =shouldDim;
            state.isSidebarExpanded = !state.isSidebarExpanded;
        },
        doLogout: (state, _) => {
            state.userToken = null;
        },
        doLogin: (state, payload) => {
            state.userToken = payload.token;
        },
    },
});

export const {
    toggleDimScreen,
    doLogout,
    doLogin,
    toggleRightSidebar,
    togglTopbarContextMenu
} = globalSlice.actions;
export default globalSlice.reducer;
